import redux, { Dispatch, Reducer } from 'redux'

export interface PeterMessage {
  message: string
  animation: string
}

export interface PeterState {
  expanded: boolean
  messages: PeterMessage[]
}

type ActionTypes = 'PETER_TOGGLE' | 'PETER_ADD_MESSAGE' | 'PETER_NEXT_MESSAGE';
type Action = redux.Action<ActionTypes> & redux.AnyAction

const initialState: PeterState = {
  expanded: false,
  messages: []
}

export const actionTypes: {[key: string]: ActionTypes} = {
  TOGGLE: 'PETER_TOGGLE',
  ADD_MESSAGE: 'PETER_ADD_MESSAGE',
  NEXT_MESSAGE: 'PETER_NEXT_MESSAGE',
}

export const peter: Reducer<PeterState, Action> = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.TOGGLE:
      return {
        ...state,
        expanded: !state.expanded
      }

    case actionTypes.ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.message]
      }

    case actionTypes.NEXT_MESSAGE:
      const messages =  [ ...state.messages ]
      messages.shift()
      return {
        ...state,
        messages
      }

  }

  return state
}

export type togglePeterType = () => any
export const togglePeter = () => async (dispatch: Dispatch<Action>) => {
  await dispatch({
    type: actionTypes.TOGGLE,
  })
}

export type addMessageType = (message: PeterMessage) => any
export const addMessage = (message: PeterMessage) => async (dispatch: Dispatch<Action>) => {
  await dispatch({
    type: actionTypes.ADD_MESSAGE,
    message
  })
}

export type nextMessageType = () => any
export const nextMessage = () => async (dispatch: Dispatch<Action>) => {
  await dispatch({
    type: actionTypes.NEXT_MESSAGE,
  })
}

export const peterInitialize = () => async (dispatch: Dispatch<Action>) => {
}
